import { useState, useEffect } from "react";

/**
 * Custom hook to determine if the user has scrolled past a certain threshold.
 * @param {number} threshold - The scroll threshold in pixels.
 * @returns {boolean} - True if scrolled past the threshold, false otherwise.
 */
export const useScrollPosition = (threshold = 10) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > threshold);
    };

    window.addEventListener("scroll", handleScroll);
    // Initial check in case the page loads already scrolled
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [threshold]);

  return scrolled;
};